import { Badge } from "@/components/ui/badge";
import { StatusPill } from "@/components/brand/StatusPill";
import { NotificationStatus } from "../types";

interface NotificationStatusBadgeProps {
  status: string;
}

export function NotificationStatusBadge({
  status,
}: NotificationStatusBadgeProps) {
  switch (status) {
    // Tinted rather than filled, and cancelled is not a failure: it is the
    // only one of these nobody needs to act on, so it stops being red.
    case NotificationStatus.SENT:
      return <StatusPill tone="success">Sent</StatusPill>;
    case NotificationStatus.FAILED:
      return <StatusPill tone="destructive">Failed</StatusPill>;
    case NotificationStatus.PENDING:
      return <StatusPill tone="info">Scheduled</StatusPill>;
    case NotificationStatus.CANCELLED:
      return <StatusPill tone="muted">Cancelled</StatusPill>;
    default:
      return <Badge>{status}</Badge>;
  }
}
